import { render, staticRenderFns } from "./FormTxApplicants.vue?vue&type=template&id=76ca3ff4&scoped=true&"
import script from "./FormTxApplicants.vue?vue&type=script&lang=js&"
export * from "./FormTxApplicants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ca3ff4",
  null
  
)

export default component.exports